import React from 'react'
import ChargebackTemplate from '../ChargebacksTemplate/ChargebackTemplate'

const Won = () => {
  return (
    <div>
      <ChargebackTemplate title='Won' status="Won"/>
    </div>
  )
}

export default Won
